var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49213 17.6895C4.63859 17.6895 0.689968 13.7217 0.689968 8.84456C0.689968 3.96744 4.63859 0 9.49213 0C14.3457 0 18.2943 3.96779 18.2943 8.84491C18.2943 13.722 14.3457 17.6898 9.49213 17.6898V17.6895ZM9.49213 3.68084C6.65851 3.68084 4.35302 5.99753 4.35302 8.84491C4.35302 11.6923 6.65851 14.009 9.49213 14.009C12.3258 14.009 14.6312 11.6923 14.6312 8.84491C14.6312 5.99753 12.3258 3.68084 9.49213 3.68084Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44145 24.0667C5.88081 24.0667 2.52779 22.679 0 20.1593L2.57952 17.5462C4.41664 19.3775 6.85355 20.3858 9.44145 20.3858C12.0294 20.3858 14.5418 19.3469 16.3887 17.4601L19 20.0413C16.4593 22.6368 13.0643 24.0667 9.44145 24.0667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49214 10.9526C10.6506 10.9526 11.5897 10.009 11.5897 8.84491C11.5897 7.68086 10.6506 6.73721 9.49214 6.73721C8.33371 6.73721 7.39462 7.68086 7.39462 8.84491C7.39462 10.009 8.33371 10.9526 9.49214 10.9526Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about-us.19d1c80d16ad6c80b12878da0bd560af.svg";
export { ForwardRef as ReactComponent };